import { toast } from 'react-toastify';

import { addLeaders, createWallet, getWallet } from 'api/copyBotApi';
import { useCopyBotAuth } from 'hooks';
import { store } from 'store';
import { Address } from 'viem';

export const useFollow = () => {
  const { account } = store.web3Store;
  const { updatePortfolioFromWallet } = store.portfolioStore;
  const { getAccessToken, clearAccessToken } = useCopyBotAuth();

  const follow = async (leaders: Address[]) => {
    if (!account || !leaders.length) return false;

    try {
      const token = await getAccessToken(account);
      const existingWallet = await getWallet(account).catch((err: any) => {
        if (err?.response?.status === 404) return null;
        throw err;
      });

      const wallet = existingWallet
        ? await addLeaders(
            account,
            {
              leaders: leaders.map((address) => ({ address, enabled: true })),
            },
            token
          )
        : await createWallet(
            {
              owner: account,
              enabled: true,
              leaders: leaders.map((address) => ({ address, enabled: true })),
            },
            token
          );

      await updatePortfolioFromWallet(wallet);
      toast.success(leaders.length > 1 ? 'Leaders added' : 'Leader added');
      return true;
    } catch (err: any) {
      if (err?.response?.status === 401) {
        clearAccessToken(account);
      }
      console.error('Failed to add leader:', err);
      toast.error(leaders.length > 1 ? 'Failed to add leaders' : 'Failed to add leader');
      return false;
    }
  };

  return follow;
};
